import { defaultFont, hexToRgb } from "assets/jss/material-dashboard-react.js";

const dialogStyle = (theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    minHeight: 350,
    height: "100%",
    width: 200,
    backgroundColor: "rgba(" + hexToRgb("#D4F0FF") + ", 0.3)",
    display: "flex",
    flexDirection: "column",
  },
  control: {
    padding: theme.spacing(2),
  },
  dialog: {
    backgroundColor: "#ECECEC",
    ...defaultFont,
  },
  title: {
    ...defaultFont,
    fontWeight: "bold",
    color: "rgba(" + hexToRgb("#252536") + ", 0.8)",
  },
  divTitle: {
    display: "flex",
    justifyContent: "center",
    margin: 10,
  },
  text: {
    color: "rgba(" + hexToRgb("#252536") + ", 0.8)",
    fontWeight: 400,
  },
  divText: {
    display: "flex",
    justifyContent: "start",
    margin: 10,
  },
  span: {
    color: "white",
  },
  index: {
    position: "relative",
    height: "auto",
    width: 10,
    borderWidth: 10,
    borderRadius: 60,
  },
});

export default dialogStyle;
